import React from 'react'

import HistoryWorkspacePage from './HistoryWorkspace'

const History: React.FC = () => <HistoryWorkspacePage mode="history" />

export default History
